import { render, staticRenderFns } from "./CardVerify.vue?vue&type=template&id=55bf532a&scoped=true"
import script from "./CardVerify.vue?vue&type=script&lang=js"
export * from "./CardVerify.vue?vue&type=script&lang=js"
import style0 from "./CardVerify.vue?vue&type=style&index=0&id=55bf532a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bf532a",
  null
  
)

export default component.exports